import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'websiteURL'})
export class WebsiteURLPipe implements PipeTransform {
     transform(value: string){
        return value.startsWith("http://") || value.startsWith("https://") ? value : "//" + value
    }
}


// WEBPACK FOOTER //
// ./src/app/ui-helper/websiteURL.pipe.ts